import React, { useEffect, useState } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaEdit,
  FaPhone,
  FaEnvelope,
  FaBuilding,
  FaGlobe,
  FaMapMarkerAlt,
  FaUser,
  FaRegAddressCard,
  FaBusinessTime,
  FaFacebookF
} from "react-icons/fa";

const CustomerCard = () => {
  const [customer, setCustomer] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [photoFile, setPhotoFile] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const customerId = decoded._id || decoded.id;

      if (!customerId) return;

      axios
        .get(`http://localhost:5890/GETMENSTIONAPI/Bussiness_details/${customerId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const fetched = response.data?.customer;
          if (fetched) setCustomer(fetched);
        })
        .catch((error) => {
          console.error("Failed to fetch:", error);
          toast.error("Failed to load customer details.");
        });
    } catch (error) {
      console.error("Token decoding failed:", error);
      toast.error("Invalid session token.");
    }
  }, []);

  const openEditModal = () => {
    setFormData({
      lastName: customer.lastName || "",
      email: customer.email || "",
      phone: customer.phone || "",
      addressLine1: customer.address?.line1 || "",
      companyName: customer.business?.companyName || "",
      website: customer.business?.website || "",
    });
    setEditModalOpen(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setPhotoFile(e.target.files[0]);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    const customerId = jwtDecode(token)._id || jwtDecode(token).id;

    const data = new FormData();
    Object.entries(formData).forEach(([key, val]) => {
      data.append(key, val);
    });
    if (photoFile) data.append("photo", photoFile);

    try {
      await axios.put(
        `http://localhost:5890/Bussiness_edit_details/${customerId}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Profile updated successfully!");
      setEditModalOpen(false);
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Error updating profile");
    }
  };

  if (!customer) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" role="status" />
        <p className="mt-2">Loading customer details...</p>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    );
  }

  return (
    <div className="container py-4">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {/* Profile Header */}
      <div className="row mb-4">
        <div className="col">
          <div className="d-flex align-items-center">
            
          </div>
        </div>
      </div>

      {/* Main Profile Card */}
      <div className="row">
        <div className="col-lg-4">
          {/* Profile Picture Card */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-primary text-white py-3">
              <h5 className="mb-0 d-flex align-items-center">
                <FaUser className="me-2" /> Profile Picture
              </h5>
            </div>
            <div className="card-body text-center">
              <div className="position-relative d-inline-block mb-3">
                <img
                  src={
                    customer.photo
                      ? `http://localhost:5890/uploads/${customer.photo}`
                      : "https://via.placeholder.com/150?text=No+Image"
                  }
                  alt="Profile"
                  className="rounded-circle border border-4 border-light shadow"
                  style={{ width: "180px", height: "180px", objectFit: "cover" }}
                />
                <span
                  className={`badge position-absolute bottom-0 end-0 rounded-pill fs-6 py-2 px-3 shadow-sm`}
                  style={{
                    transform: "translate(-25%, -25%)",
                    backgroundColor: customer.status === "Inactive" ? "#dc3545" : "#198754",
                  }}
                >
                  {customer.status === "Inactive" ? "Inactive" : "Active"}
                </span>
              </div>
              <h4 className="mb-2">{customer.lastName}</h4>
              <p className="text-muted mb-3">{customer.business?.companyName}</p>
              <button 
                onClick={openEditModal}
                className="btn btn-outline-primary btn-sm"
              >
                <FaEdit className="me-1" /> Edit Profile
              </button>
            </div>
          </div>

          {/* Contact Information Card */}
          <div className="card shadow-sm">
            <div className="card-header bg-primary text-white py-3">
              <h5 className="mb-0 d-flex align-items-center">
                <FaRegAddressCard className="me-2" /> Contact Information
              </h5>
            </div>
            <div className="card-body">
              <ul className="list-unstyled">
                <li className="mb-3 d-flex">
                  <div className="me-3 text-primary">
                    <FaEnvelope size={20} />
                  </div>
                  <div>
                    <h6 className="mb-0 text-muted small">Email</h6>
                    <p className="mb-0">{customer.email || "Not provided"}</p>
                  </div>
                </li>
                <li className="mb-3 d-flex">
                  <div className="me-3 text-primary">
                    <FaPhone size={20} />
                  </div>
                  <div>
                    <h6 className="mb-0 text-muted small">Phone</h6>
                    <p className="mb-0">{customer.phone || "Not provided"}</p>
                  </div>
                </li>
                <li className="d-flex">
                  <div className="me-3 text-primary">
                    <FaMapMarkerAlt size={20} />
                  </div>
                  <div>
                    <h6 className="mb-0 text-muted small">Address</h6>
                    <p className="mb-0">{customer.address?.line1 || "Not provided"}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Business Details Card */}
        <div className="col-lg-8">
          <div className="card shadow-sm mb-4">
            <div className="card-header bg-primary text-white py-3">
              <h5 className="mb-0 d-flex align-items-center">
                <FaBusinessTime className="me-2" /> Business Details
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="d-flex align-items-start">
                    <div className="me-3 text-primary">
                      <FaBuilding size={20} />
                    </div>
                    <div>
                      <h6 className="mb-1 text-muted small">Company Name</h6>
                      <p className="mb-0 fs-5">{customer.business?.companyName || "Not provided"}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="d-flex align-items-start">
                    <div className="me-3 text-primary">
                      <FaGlobe size={20} />
                    </div>
                    <div>
                      <h6 className="mb-1 text-muted small">Website</h6>
                      <p className="mb-0 fs-5">
                        {customer.business?.website ? (
                          <a href={customer.business.website} target="_blank" rel="noopener noreferrer">
                            {customer.business.website}
                          </a>
                        ) : "Not provided"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="d-flex justify-content-between align-items-center border-top pt-3 mt-3">
                <small className="text-muted">
                  Last updated: {customer.updatedAt ? new Date(customer.updatedAt).toLocaleString() : "Unknown"}
                </small>
                <button 
                  onClick={openEditModal}
                  className="btn btn-primary btn-sm"
                >
                  <FaEdit className="me-1" /> Edit Business Details
                </button>
              </div>
            </div>
          </div>

          <div className="card shadow-sm">
            <div className="card-header bg-primary text-white py-3">
              <h5 className="mb-0">Additional Information</h5>
            </div>
            <div className="card-body">
 
                <div className="col-md-6 mb-4">
                  <div className="d-flex align-items-start">
                    <div className="me-3 text-primary">
                      <FaFacebookF size={20} />
                    </div>
                    <div>
                      <h6 className="mb-1 text-muted small">Face Book</h6>
                      <p className="mb-0 fs-5">{customer.business.social?.facebook || "Not provided"}</p>
                    </div>
                  </div>
                </div>            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {editModalOpen && (
        <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Edit Profile Information</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={() => setEditModalOpen(false)}
                ></button>
              </div>
              <form onSubmit={handleUpdate} encType="multipart/form-data">
                <div className="modal-body">
                  <div className="container-fluid">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Last Name</label>
                          <input 
                            type="text" 
                            name="lastName" 
                            className="form-control" 
                            value={formData.lastName} 
                            onChange={handleInputChange} 
                            required 
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Email</label>
                          <input 
                            type="email" 
                            name="email" 
                            className="form-control" 
                            value={formData.email} 
                            onChange={handleInputChange} 
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Phone</label>
                          <input 
                            type="text" 
                            name="phone" 
                            className="form-control" 
                            value={formData.phone} 
                            onChange={handleInputChange} 
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Company Name</label>
                          <input 
                            type="text" 
                            name="companyName" 
                            className="form-control" 
                            value={formData.companyName} 
                            onChange={handleInputChange} 
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Website</label>
                          <input 
                            type="text" 
                            name="website" 
                            className="form-control" 
                            value={formData.website} 
                            onChange={handleInputChange} 
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Profile Photo</label>
                          <input 
                            type="file" 
                            name="photo" 
                            className="form-control" 
                            onChange={handleFileChange} 
                            accept="image/*" 
                          />
                          <small className="text-muted">Max file size: 5MB</small>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-3">
                          <label className="form-label">Address</label>
                          <input 
                            type="text" 
                            name="addressLine1" 
                            className="form-control" 
                            value={formData.addressLine1} 
                            onChange={handleInputChange} 
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-top">
                  <button 
                    type="button" 
                    className="btn btn-outline-secondary" 
                    onClick={() => setEditModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-primary"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerCard;